<template>
  <div class="container">
    <v-card>
      <v-toolbar class="mt-12" dark color="primary">
        <v-toolbar-title>Reporte de Inasistencias - Turnos Fijos</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <v-text-field
              v-model="fechaDesde"
              label="Fecha Desde"
              prepend-icon="mdi-calendar"
              type="date"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-text-field
              v-model="fechaHasta"
              label="Fecha Hasta"
              prepend-icon="mdi-calendar"
              type="date"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="3" class="d-flex align-center">
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="!fechaDesde || !fechaHasta"
              @click="buscar"
            >
              Buscar
              <v-icon right>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="inasistencias.length > 0">
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="filtroNombre"
              label="Filtrar por nombre del jugador"
              prepend-icon="mdi-account-search"
              dense
              clearable
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Tabla agrupada -->
      <v-card-text v-if="inasistenciasAgrupadas.length > 0">
        <v-expansion-panels accordion>
          <v-expansion-panel
            v-for="grupo in inasistenciasAgrupadas"
            :key="grupo.clave"
          >
            <v-expansion-panel-header>
              <div class="d-flex justify-space-between align-center" style="width: 100%">
                <div>
                  <strong>{{ grupo.nombreJugador }}</strong>
                  <v-chip small class="ml-2" color="indigo" dark>
                    {{ grupo.diaSemana }} {{ grupo.horaInicioString }}
                  </v-chip>
                </div>
                <v-chip small :color="grupo.cantInasistencias >= 3 ? 'error' : 'warning'" dark class="mr-4">
                  {{ grupo.cantInasistencias }} inasistencia{{ grupo.cantInasistencias > 1 ? 's' : '' }}
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Motivo</th>
                    <th>Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in grupo.detalle" :key="item.idAusencia">
                    <td>{{ item.fechaTurno }}</td>
                    <td>
                      <v-chip x-small :color="getColorMotivo(item.motivo)" dark>
                        {{ item.motivo || '—' }}
                      </v-chip>
                    </td>
                    <td>{{ item.observaciones || '—' }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-card-text v-else-if="buscado && !loading">
        <v-alert color="purple" dark outlined>
          No hay inasistencias registradas para el rango de fechas seleccionado.
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-btn dark color="#24232d" @click="$router.push('/Home')">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "@/axios-auth";

export default {
  name: "ReporteInasistencias",
  data() {
    return {
      fechaDesde: null,
      fechaHasta: null,
      filtroNombre: null,
      inasistencias: [],
      loading: false,
      buscado: false,
    };
  },
  computed: {
    inasistenciasAgrupadas() {
      const mapa = {};
      const filtro = (this.filtroNombre || "").trim().toLowerCase();
      this.inasistencias
        .filter((item) => !filtro || item.nombreJugador.toLowerCase().includes(filtro))
        .forEach((item) => {
          const clave = `${item.idPaciente}_${item.diaSemana}_${item.horaInicioString}`;
          if (!mapa[clave]) {
            mapa[clave] = {
              clave,
              idPaciente: item.idPaciente,
              nombreJugador: item.nombreJugador,
              diaSemana: item.diaSemana,
              horaInicioString: item.horaInicioString,
              cantInasistencias: 0,
              detalle: [],
            };
          }
          mapa[clave].cantInasistencias++;
          mapa[clave].detalle.push(item);
        });
      return Object.values(mapa).sort(
        (a, b) => b.cantInasistencias - a.cantInasistencias,
      );
    },
  },
  methods: {
    async buscar() {
      this.loading = true;
      this.buscado = true;
      try {
        const { data } = await axios.get("/Turnos/ReporteInasistenciasTurnoFijo", {
          params: {
            fechaDesde: this.fechaDesde,
            fechaHasta: this.fechaHasta,
          },
        });
        this.inasistencias = data || [];
      } catch (e) {
        this.inasistencias = [];
      }
      this.loading = false;
    },
    getColorMotivo(motivo) {
      if (motivo === "Fuerza Mayor") return "blue-grey";
      if (motivo === "Incumplimiento del Jugador") return "error";
      if (motivo === "No Jugado pero abonado") return "success";
      return "grey";
    },
  },
  created() {
    const hoy = new Date().toISOString().substring(0, 10);
    const hace30 = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
      .toISOString()
      .substring(0, 10);
    this.fechaDesde = hace30;
    this.fechaHasta = hoy;
  },
};
</script>

<style scoped>
.container {
  margin: auto;
}
</style>
